
import { z } from "zod";

export const registerSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().optional(),
  email: z.string().email("Please enter a valid email address"),
  password: z
    .string()
    .min(8, "Password must be at least 8 characters")
    .refine(
      (password) => {
        // Check if password has at least one uppercase letter
        const hasUppercase = /[A-Z]/.test(password);
        // Check if password has at least one lowercase letter
        const hasLowercase = /[a-z]/.test(password);
        // Check if password has at least one number
        const hasNumber = /[0-9]/.test(password);
        // Check if password has at least one special character
        const hasSpecial = /[^A-Za-z0-9]/.test(password);
        
        return hasUppercase && hasLowercase && hasNumber && hasSpecial;
      },
      {
        message: "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character"
      }
    ),
  agreeToTerms: z.boolean().refine(val => val === true, {
    message: "You must accept the terms and conditions to continue"
  })
});
